import { render } from "./Tabs.vue?vue&type=template&id=2d4bf589&scoped=true"
import script from "./Tabs.vue?vue&type=script&lang=ts"
export * from "./Tabs.vue?vue&type=script&lang=ts"

import "./Tabs.vue?vue&type=style&index=0&id=2d4bf589&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2d4bf589"

export default script